import { MemberContractViewModel } from './memberContract.view-model';

export class SuggestedContractViewModel {
    public brand: string;
    public cid: string;
    public delegation?: any;
    public detail: string;
    public member: MemberContractViewModel;
    public offerName: string;
    public role: string;
    public state: string;
    public type: string;
}
